window.addEventListener("load", () => {
  const slider = document.querySelector(".gr-media-gallery__nav");
  const nextItem = document.querySelector(".media-gallery__arrow--next");
  const prevItem = document.querySelector(".media-gallery__arrow--prev");

  if (slider && nextItem && prevItem) {
    const updateShadows = () => {
      if (nextItem.classList.contains("slick-disabled")) {
        slider.classList.add("hide-right-shadow");
      } else {
        slider.classList.remove("hide-right-shadow");
      }

      if (prevItem.classList.contains("slick-disabled")) {
        slider.classList.add("hide-left-shadow");
      } else {
        slider.classList.remove("hide-left-shadow");
      }
    };

    const observerNext = new MutationObserver(updateShadows);
    const observerPrev = new MutationObserver(updateShadows);

    observerNext.observe(nextItem, { attributes: true, attributeFilter: ["class"] });
    observerPrev.observe(prevItem, { attributes: true, attributeFilter: ["class"] });

    updateShadows();
  }
});
